import type { MetaArgs } from "react-router"

type ContentValues = {
  title: string
  description: string
  ogImageUrl?: string
  ogType?: "website" | "article"
}

/**
 * root.tsx内のMetaFunctionで定義しているog:imageをデフォルト値として、それを取り出すためにmatchesを使う。
 * matchesはMetaFunctionの引数から取得すること。
 * @example
 * ```
 * export const meta: MetaFunction = ({ matches }) => {
 *   getTemplatedMetaArray(matches, {...})
 *   ...
 * }
 * ```
 */
export const getTemplatedMetaArray = (
  matches: MetaArgs["matches"],
  { title, description, ogImageUrl, ogType = "website" }: ContentValues,
) => {
  const rootOgImageUrl = extractRootOgImageUrl(matches)

  return [
    { title: title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: ogImageUrl ?? rootOgImageUrl },
    { property: "og:type", content: ogType },
  ]
}

export const extractRootOgImageUrl = (matches: MetaArgs["matches"]) => {
  const rootMatchResult = matches[0]
  const rootOgImageMeta = rootMatchResult.meta.find((meta) => {
    // @ts-expect-error: 何故かmetaの型が上手く適用されない
    return meta?.property === "og:image"
  })
  // @ts-expect-error: 上記同様、何故かmetaの型が上手く適用されない
  const rootOgImageUrl = rootOgImageMeta?.content as string | undefined

  return rootOgImageUrl
}
